import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { Avatar } from '../components/Avatar';
import { Input } from '../components/Input';
import { SearchIcon } from 'lucide-react';
export const Messages = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  // Mock data for conversations
  const conversations = [{
    id: 'c1',
    user: {
      id: 'u1',
      name: 'Sarah Johnson',
      avatar: 'https://randomuser.me/api/portraits/women/12.jpg'
    },
    lastMessage: {
      text: 'Thanks for accepting my request! Looking forward to the event.',
      timestamp: '10:23 AM',
      unread: true
    },
    event: 'Summer Club Night'
  }, {
    id: 'c2',
    user: {
      id: 'u2',
      name: 'Michael Smith',
      avatar: 'https://randomuser.me/api/portraits/men/22.jpg'
    },
    lastMessage: {
      text: 'I can bring a bottle of champagne. Is that ok?',
      timestamp: 'Yesterday',
      unread: false
    },
    event: 'Summer Club Night'
  }, {
    id: 'c3',
    user: {
      id: 'u3',
      name: 'Emma Wilson',
      avatar: 'https://randomuser.me/api/portraits/women/33.jpg'
    },
    lastMessage: {
      text: 'What time should we arrive at the venue?',
      timestamp: 'Jul 10',
      unread: false
    },
    event: 'Rooftop Party'
  }];
  const filteredConversations = searchQuery ? conversations.filter(convo => convo.user.name.toLowerCase().includes(searchQuery.toLowerCase()) || convo.lastMessage.text.toLowerCase().includes(searchQuery.toLowerCase())) : conversations;
  const handleOpenConversation = (id: string) => {
    navigate(`/conversation/${id}`);
  };
  return <div className="bg-white min-h-screen pb-16" data-id="element-414">
      <Header title="Messages" data-id="element-415" />
      <div className="p-4" data-id="element-416">
        <div className="mb-4" data-id="element-417">
          <Input startAdornment={<SearchIcon className="h-4 w-4 text-gray-500" data-id="element-419" />} placeholder="Search messages..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-418" />
        </div>
        {filteredConversations.length === 0 ? <div className="text-center py-8 text-gray-500" data-id="element-420">
            No conversations found
          </div> : filteredConversations.map(conversation => <div key={conversation.id} className="border-b border-gray-200 py-3 flex items-start cursor-pointer" onClick={() => handleOpenConversation(conversation.id)} data-id="element-421">
              <Avatar name={conversation.user.name} alt={conversation.user.name} src={conversation.user.avatar} size="md" data-id="element-422" />
              <div className="ml-3 flex-1 min-w-0" data-id="element-423">
                <div className="flex justify-between items-baseline" data-id="element-424">
                  <h3 className="font-medium text-gray-800 truncate" data-id="element-425">
                    {conversation.user.name}
                  </h3>
                  <span className="text-xs text-gray-500 whitespace-nowrap ml-2" data-id="element-426">
                    {conversation.lastMessage.timestamp}
                  </span>
                </div>
                <p className={`text-sm truncate ${conversation.lastMessage.unread ? 'font-medium text-gray-800' : 'text-gray-600'}`} data-id="element-427">
                  {conversation.lastMessage.text}
                </p>
                <p className="text-xs text-gray-500 mt-1" data-id="element-428">
                  {conversation.event}
                </p>
              </div>
              {conversation.lastMessage.unread && <div className="h-2 w-2 bg-gray-800 rounded-full mt-2 ml-1" data-id="element-429"></div>}
            </div>)}
      </div>
      <Navigation data-id="element-430" />
    </div>;
};